import { render, staticRenderFns } from "./BusinessGroupDetailView.vue?vue&type=template&id=30201aa0&lang=pug&"
import script from "./BusinessGroupDetailView.vue?vue&type=script&lang=js&"
export * from "./BusinessGroupDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports